<div [class]="theme ? theme : 'one-portal'">
  <ecp-loader *ngIf="generating"></ecp-loader>
    <ng-container *ngIf="generatedLabel">
    <div class="row mb-10">
      <div class="col s12">
        <p class="text-green">Shipping Label has been Generated</p>
        <h3>Tracking Number : {{ generatedLabel?.trackingNumber }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <img [src]="'data:image/png;base64,' + generatedLabel?.labelBinary" alt="Generated Label" class="label-image" />
      </div>
    </div>
    <div class="row">
      <div class="col s12 text-center">
        <button class="btn btn-primary print-button" (click)="printLabel()">Print and Close</button>
      </div>
    </div>
    </ng-container>
</div>
